
import { Options, prop, Vue } from "vue-class-component";
import { CustomerSavedPackage } from "@/domain/entities/Customer";

class Props {
  index = prop<number>({ default: 1, type: Number });
  savedPackage = prop<CustomerSavedPackage>({ required: true });
  editable = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  name: "SavedPackageRow",
  emits: ["edit", "delete"]
})
export default class SavedPackageRow extends Vue.with(Props) {
  get displayName(): string {
    const name = this.savedPackage.commodityName || this.savedPackage.commodityCode;
    return this.toSentenceCase(name);
  }

  toSentenceCase(val: string): string {
    if (!val) return "";
    const isAllUpper = val === val.toUpperCase() && val !== val.toLowerCase();
    if (!isAllUpper) return val;
    return val
      .toLowerCase()
      .split(" ")
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
      .join(" ");
  }
}
